export default __webpack_public_path__ + "static/media/s-10.ad963aec.jpg";